import type { MainMenu } from "./types";

export const footerMenu: MainMenu = [
  { name: "Home", href: "/" },
  { name: "About Us", href: "/company/about" },
  { name: "Privacy Policy", href: "/privacy-policy" },
];
